import { render, staticRenderFns } from "./Push.vue?vue&type=template&id=4bb4e4c2&scoped=true&"
import script from "./Push.vue?vue&type=script&lang=js&"
export * from "./Push.vue?vue&type=script&lang=js&"
import style0 from "./Push.vue?vue&type=style&index=0&id=4bb4e4c2&scoped=true&lang=css&"
import style1 from "./Push.vue?vue&type=style&index=1&id=4bb4e4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4e4c2",
  null
  
)

export default component.exports